// Reputation chip rendered next to an author's name on every forum surface.
//
// The badge ramps visually with rep — bronze (1-49) → silver (50-249) →
// gold (250+). Below 1 (brand-new users) we render nothing rather than a
// confusing "0 rep" badge.
import { Trophy } from "lucide-react";

const TIERS = [
  { min: 250, label: "Gold",   className: "bg-amber-100 text-amber-800 border-amber-300" },
  { min: 50,  label: "Silver", className: "bg-zinc-200 text-zinc-800 border-zinc-300" },
  { min: 1,   label: "Bronze", className: "bg-orange-100 text-orange-800 border-orange-300" },
];

function tierFor(rep) {
  for (const t of TIERS) if (rep >= t.min) return t;
  return null;
}

export default function ReputationBadge({ reputation, compact }) {
  const rep = Number(reputation) || 0;
  const tier = tierFor(rep);
  if (!tier) return null;
  return (
    <span
      className={
        "inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-[10px] font-bold leading-none " +
        tier.className
      }
      title={`${tier.label} contributor · ${rep} forum rep`}
      data-testid={`rep-badge-${rep}`}
    >
      <Trophy size={10} />
      {compact ? rep : `${rep} rep`}
    </span>
  );
}
